import cn from 'classnames';
import { FC } from 'react';
import { GoCheck } from 'react-icons/go';
import { LangEnum } from '../../../../../helpers/lang';
import { useIsMobile } from '../../../../../hooks/use-is-mobile';
import { FLAGS, LANG_OPTIONS } from '../constants';
import s from './lang-list.module.css';

interface Props {
  currentLang: LangEnum;
  onSelect: (lang: LangEnum) => void;
}

export const LangList: FC<Props> = ({ currentLang, onSelect }) => {
  const isMobile = useIsMobile();

  return (
    <ul className={cn(s.list, isMobile && s.mobile)}>
      {LANG_OPTIONS.map(({ id, label }) => (
        <li key={id} className={s.item} onClick={() => onSelect(id)} role="option">
          {FLAGS[id]}
          {label}
          {currentLang === id && <GoCheck className={s.check} />}
        </li>
      ))}
    </ul>
  );
};
